// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"spinner_wrapper__3dV28","text":"spinner_text__1Kc-d","white":"spinner_white__1J76J","spin":"spinner_spin__O7Dy2","overlay":"spinner_overlay__1fCor"};